"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.CallIcon = (0, react_1.forwardRef)(function CallIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M8.15918 15.7852C10.8574 18.501 14.1182 20.5664 16.7725 20.5664C17.959 20.5664 19.0049 20.1621 19.8486 19.2305C20.332 18.6855 20.6045 18.0791 20.6045 17.4639C20.6045 16.9365 20.4023 16.4355 19.9014 16.0752L17.1855 14.1416C16.7373 13.8252 16.3682 13.6846 16.0342 13.6846C15.6035 13.6846 15.2256 13.9307 14.8125 14.3438L14.1533 14.9941C14.0566 15.0996 13.9248 15.1348 13.8105 15.1348C13.6699 15.1348 13.5205 15.082 13.4238 15.0293C12.8613 14.7129 11.877 13.8691 10.9805 12.9639C10.084 12.0674 9.24023 11.0918 8.92383 10.5205C8.8623 10.4238 8.80957 10.2832 8.80957 10.1426C8.80957 10.0283 8.85352 9.90527 8.9502 9.7998L9.60938 9.14062C10.0225 8.71875 10.2686 8.34082 10.2686 7.91016C10.2686 7.57617 10.1191 7.20703 9.80273 6.76758L7.87793 4.06055C7.52637 3.56836 7.00781 3.35742 6.46289 3.35742C5.84766 3.35742 5.25 3.6123 4.71387 4.11328C3.7998 4.95703 3.39551 6.01172 3.39551 7.18945C3.39551 9.85254 5.45215 13.0869 8.15918 15.7852Z", fill: "currentColor" })));
});
